/**
 * Stories implemented by ZillowNavbar
 */
/* eslint-disable local-rules/require-storybook-documentation */
import { FunctionComponent } from 'react';
import { HeaderSubSection } from 'src/components/ZillowNavbar/page-frame-types/HeaderSubSection';
import { isHeaderLink } from 'src/components/ZillowNavbar/utils/isHeaderLink';
import { ZillowNavbarNotification } from 'src/components/ZillowNavbar/components/ZillowNavbarNotification';
import { MobileDropdownMenuSubSectionContainer } from './components/MobileDropdownMenuSubSectionContainer';
import { MobileDropdownMenuSubSectionLinkContainer } from './components/MobileDropdownMenuSubSectionLinkContainer';
import { MobileDropdownMenuSubSectionTitle } from './components/MobileDropdownMenuSubSectionTitle';
import { MobileDropdownMenuSubSectionLinks } from './components/MobileDropdownMenuSubSectionLinks';
import { MobileDropdownMenuSubSectionLinkAnchor } from './components/MobileDropdownMenuSubSectionLinkAnchor';
import { MobileDropdownMenuSubSectionLinkDescription } from './components/MobileDropdownMenuSubSectionLinkDescription';

export type MobileDropdownMenuSubSectionProps = {
    subsection: HeaderSubSection;
};

export const MobileDropdownMenuSubSection: FunctionComponent<MobileDropdownMenuSubSectionProps> = ({ subsection }) => (
    <MobileDropdownMenuSubSectionContainer>
        {subsection.title && (
            <MobileDropdownMenuSubSectionTitle level={6}>{subsection.title}</MobileDropdownMenuSubSectionTitle>
        )}
        <MobileDropdownMenuSubSectionLinks>
            {subsection.links.map((linksOrLinkOrDescription, index) => {
                if (Array.isArray(linksOrLinkOrDescription)) {
                    return linksOrLinkOrDescription.flatMap((sublink, index) => {
                        if (isHeaderLink(sublink)) {
                            return (
                                <MobileDropdownMenuSubSectionLinkContainer key={sublink.href}>
                                    <MobileDropdownMenuSubSectionLinkAnchor href={sublink.href}>
                                        {sublink.text}
                                        {!!sublink.notifications && (
                                            <ZillowNavbarNotification>{sublink.notifications}</ZillowNavbarNotification>
                                        )}
                                    </MobileDropdownMenuSubSectionLinkAnchor>
                                </MobileDropdownMenuSubSectionLinkContainer>
                            );
                        }
                        return (
                            <MobileDropdownMenuSubSectionLinkContainer key={`${sublink.text}-${index}`}>
                                <MobileDropdownMenuSubSectionLinkDescription>
                                    {sublink.text}
                                </MobileDropdownMenuSubSectionLinkDescription>
                            </MobileDropdownMenuSubSectionLinkContainer>
                        );
                    });
                }
                if (isHeaderLink(linksOrLinkOrDescription)) {
                    return (
                        <MobileDropdownMenuSubSectionLinkContainer key={linksOrLinkOrDescription.href}>
                            <MobileDropdownMenuSubSectionLinkAnchor href={linksOrLinkOrDescription.href}>
                                {linksOrLinkOrDescription.text}
                                {!!linksOrLinkOrDescription.notifications && (
                                    <ZillowNavbarNotification>
                                        {linksOrLinkOrDescription.notifications}
                                    </ZillowNavbarNotification>
                                )}
                            </MobileDropdownMenuSubSectionLinkAnchor>
                        </MobileDropdownMenuSubSectionLinkContainer>
                    );
                }
                return (
                    <MobileDropdownMenuSubSectionLinkContainer key={`${linksOrLinkOrDescription.text}-${index}`}>
                        <MobileDropdownMenuSubSectionLinkDescription>
                            {linksOrLinkOrDescription.text}
                        </MobileDropdownMenuSubSectionLinkDescription>
                    </MobileDropdownMenuSubSectionLinkContainer>
                );
            })}
        </MobileDropdownMenuSubSectionLinks>
    </MobileDropdownMenuSubSectionContainer>
);
